export default {
    data: () => ({
        translations: {
            title: {
                el: "Θερμικός εκτυπωτής",
                en: "Thermal Printer",
                it: "Stampante Termica"
            },
            info: {
                el: "Η ενεργοποίηση του 'Θερμικός εκτυπωτής' θα σας επιτρέψει να εκτυπώνετε και να παρέχετε αποδείξεις αναλυτικής ποντοδοσίας στους πελάτες σας βάσει των αγορών τους.",
                en: `
                Enabling 'Thermal Printer' will allow you to print and provide detailed point receipts to your customers based on their purchases.
                `,
                it: "L'abilitazione della 'stampante termica' vi permetterà di stampare e fornire ricevute dettagliate ai vostri clienti in base ai loro acquisti."
            },
            toggle: {
                el: "Ενεργοποίηση Θερμικού εκτυπωτή",
                en: "Activate Thermal Printer",
                it: "Attivare Stampante Termica"
            },
            on: {
                el: "Ενεργό",
                en: "On",
                it: "Sopra"
            },
            off: {
                el: "Ανενεργό",
                en: "Off",
                it: "Off"
            }
        }
    })
};
